import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import EquipmentServiceHistoryGrid from '../../../../../components/service/equipmentServiceHistoryGrid/equipmentServiceHistoryGrid.component';
import { useHasPermission } from '../../../../../contexts/auth';

export const EquipmentServiceHistory = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const canViewAllJobs = useHasPermission("service.view_job");
  const canViewOwnJobs = useHasPermission("service.view_own_job");
  const canViewJobs = canViewAllJobs || canViewOwnJobs;

  if (!canViewJobs) {
    return null;
  }

  return (
    <EquipmentServiceHistoryGrid
      equipmentId={id}
      title={t('Service History')}
      gridSettingsKey="EQUIPMENT_SERVICE_HISTORY"
      refreshEventName="equipmentJobAdded"
    />
  );
};
